export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'dlgDashBoard';
export const NAME = 'Zpravy';

export enum ZPRAVA_DRUH {
	ZPRAVY = 1,
	NOVINKY = 2,
	SYSTEMOVE_ZPRAVY = 3,
	SMS = 4,
	POZNAMKY = 5,
	ODESLANE = 6,
	SYSTEMOVA_UPOZORNENI = 7,
}

export const TAB_NAMES = <const>{
	ZPRAVY: 'Zpravy',
	NOVINKY: 'Novinky',
	SYSTEMOVE_ZPRAVY: 'SystemoveZpravy',
	SMS: 'SMS',
	POZNAMKY: 'Poznamky',
	ODESLANE: 'Odeslane',
	SYSTEMOVA_UPOZORNENI: 'SystemovaUpozorneni',
};

export const tabItems = {
	[TAB_NAMES.ZPRAVY]: { id: TAB_NAMES.ZPRAVY, labelKey: 'DashboardLocal', druh: ZPRAVA_DRUH.ZPRAVY },
	[TAB_NAMES.ODESLANE]: { id: TAB_NAMES.ODESLANE, labelKey: 'DashboardOdeslane', druh: ZPRAVA_DRUH.ODESLANE },
	[TAB_NAMES.POZNAMKY]: { id: TAB_NAMES.POZNAMKY, labelKey: 'DashboardPoznamky', druh: ZPRAVA_DRUH.POZNAMKY },
	[TAB_NAMES.SMS]: { id: TAB_NAMES.SMS, labelKey: 'DashboardSMS', druh: ZPRAVA_DRUH.SMS },
	[TAB_NAMES.SYSTEMOVE_ZPRAVY]: { id: TAB_NAMES.SYSTEMOVE_ZPRAVY, labelKey: 'DashboardSystem', druh: ZPRAVA_DRUH.SYSTEMOVE_ZPRAVY },
	[TAB_NAMES.SYSTEMOVA_UPOZORNENI]: { id: TAB_NAMES.SYSTEMOVA_UPOZORNENI, labelKey: 'DashboardSystemWarn', druh: ZPRAVA_DRUH.SYSTEMOVA_UPOZORNENI },
};
